import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Dropdown } from '@rexlabs/select';
var quarterHours = ['00', '15', '30', '45'];
var times = [];

for (var i = 0; i < 24; i++) {
  for (var j = 0; j < 4; j++) {
    var _context, _context2, _context3, _context4;

    times.push({
      label: _concatInstanceProperty(_context = "".concat(_sliceInstanceProperty(_context2 = '0' + i).call(_context2, -2), ":")).call(_context, quarterHours[j]),
      value: _concatInstanceProperty(_context3 = "".concat(_sliceInstanceProperty(_context4 = '0' + i).call(_context4, -2))).call(_context3, quarterHours[j])
    });
  }
}

var TimeInput = /*#__PURE__*/function (_Component) {
  _inherits(TimeInput, _Component);

  var _super = _createSuper(TimeInput);

  function TimeInput() {
    _classCallCheck(this, TimeInput);

    return _super.apply(this, arguments);
  }

  _createClass(TimeInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Dropdown, _extends({}, this.props, {
        items: times
      }));
    }
  }]);

  return TimeInput;
}(Component);

export default TimeInput;